import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import CreateImageCode from '../../components/ExcerciseTypes/Design/CreateImageCode';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'WB4-V2-U11-P74-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page74/E1/Key/answerKey.png',
    inputSize: 30,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page74/2.jpg' /> </div>
          <div style=" position: absolute; top: 133px; left: 645px; "><input id='0' /></div>
          <div style=" position: absolute; top: 113px; left: 477px; "><input id='1' /></div>
          <div style=" position: absolute; top: 159px; left: 207px; "><input id='2' /></div>
          <div style=" position: absolute; top: 224px; left: 95px; "><input id='3' /></div>
         
        </div>
        `,
        answer: [
          "5",
          "4",
          "2",
          "3",

        ],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'WB4-V2-U11-P74-E2',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page74/E2/Key/answerKey.png',
    inputSize: 90,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page74/E2/1.jpg' /> </div>
          <div style=" position: absolute; top: 143px; left: 454px; "><input id='0' /></div>
          <div style=" position: absolute; top: 238px; left: 495px; "><input id='1' /></div>
          <div style=" position: absolute; top: 333px; left: 462px; "><input id='2' /></div>
          <div style=" position: absolute; top: 426px; left: 378px; "><input id='3' /></div>
         
        </div>
        `,
        answer: [
          "no",
          "yes",
          "yes",
          "no",
        ],
      },
    ],
  },




}
export default json;